module.exports = __webpack_public_path__ + "static/power-img2-1@2x-2587f6c54169641c33b72d2dff5f9447.png";